import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import MetaTags from "react-meta-tags";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import Layout from "../../layout/Layout";
import Breadcrumb from "../../helpers/components/breadcrumb/BreadCrumb";
import {
  multilanguage
} from "redux-multilanguage"

const NotFound = ({ location, strings }) => {
  const { pathname } = location;

  return (
    <Fragment>
      <MetaTags>
        <title>IOLA FASHION | {strings['appPages']['404']}</title>
        <meta
          name="description"
          content="High Quality Seamless Active Wear"
        />
      </MetaTags>
      <BreadcrumbsItem to={process.env.PUBLIC_URL + "/"}>{strings['appPages']['home']}</BreadcrumbsItem>
      <BreadcrumbsItem to={process.env.PUBLIC_URL + pathname}>
        {strings['appPages']['404']}
      </BreadcrumbsItem>
      <Layout >
        {/* breadcrumb */}
        <Breadcrumb />
        <div className="error-area pt-40 pb-100">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-7 col-lg-8 text-center">
                <div className="error">
                  <h1>{strings['404']['title']}</h1>
                  <h2>{strings['404']['subtitle']}</h2>
                  <p>
                    {strings['404']['description']}
                  </p>

                  <Link to={process.env.PUBLIC_URL + "/"} className="error-btn">
                    {strings['404']['button']}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </Fragment>
  );
};

NotFound.propTypes = {
  location: PropTypes.object
};

export default multilanguage(NotFound);
